const baseUrl = process.env.VUE_APP_BASE_URL;

const api = '/api';
const userValidate = '/user-validate';
const validateLimit = '/validate-limit';
const logOut = '/logout';
const oauthToken = '/oauth/v2/token';
const superAdminValidate = '/super-admin-validate';

const user = '/user';
const superAdmin = '/super-admin';
const customField = '/custom-field';
const setting = '/setting';
const customer = '/customer';
const group = '/group';
const publicationItem = '/publication-item';
const publication = '/publication';
const file = '/file';
const clientToken = '/client-token';
const token = '/validate-token';
const membership = '/membership';
const banner = '/banner';
const signedDocument = '/signed-document';

const enable = '/enable';
const changePassword = '/change-password';
const changeStatus = '/change-status';
const list = '/list';
// const publish = '/publish';
const lock = '/lock';
const firebaseFile = 'firebase-messaging-sw.js';
const logs = '/logs';
const getEmails = '/get-emails';
const getUsersByGroup = '/get-by-group';
const getSignableList = '/get-signable-list';

module.exports = {
    userValidateUrl: () => `${baseUrl}${userValidate}`,
    oauthTokenUrl: () => `${baseUrl}${oauthToken}`,
    superAdminValidateUrl: () => `${baseUrl}${superAdminValidate}`,
    superAdminlogOutUrl: () => `${baseUrl}${api}${superAdmin}${logOut}`,
    logOutUrl: () => `${baseUrl}${api}${logOut}`,
    userUrl: () => `${baseUrl}${api}${user}`,
    userTokenUrl: () => `${baseUrl}${api}${user}${token}`,
    userEnableUrl: () => `${baseUrl}${api}${user}${enable}`,
    userChangePasswordUrl: () => `${baseUrl}${api}${user}${changePassword}`,
    emailsByCustomerUrl: () => `${baseUrl}${api}${user}${getEmails}`,
    usersByGroupUrl: () => `${baseUrl}${api}${user}${getUsersByGroup}`,
    userListUrl: () => `${baseUrl}${api}${user}${list}`,
    customFieldUrl: () => `${baseUrl}${api}${customField}`,
    settingUrl: () => `${baseUrl}${api}${setting}`,
    customerUrl: () => `${baseUrl}${api}${customer}`,
    customerEnableUrl: () => `${baseUrl}${api}${customer}${enable}`,
    customerListUrl: () => `${baseUrl}${api}${customer}${list}`,
    groupUrl: () => `${baseUrl}${api}${group}`,
    groupEnableUrl: () => `${baseUrl}${api}${group}${enable}`,
    groupListUrl: () => `${baseUrl}${api}${group}${list}`,
    publicationItemUrl: () => `${baseUrl}${api}${publicationItem}`,
    publicationItemsListUrl: () => `${baseUrl}${api}${publicationItem}${list}`,
    publicationItemChangeStatusUrl: () => `${baseUrl}${api}${publicationItem}${changeStatus}`,
    publicationItemLockUrl: () => `${baseUrl}${api}${publicationItem}${lock}`,
    publicationUrl: () => `${baseUrl}${api}${publication}`,
    publicationLockUrl: () => `${baseUrl}${api}${publication}${lock}`,
    postListUrl: () => `${baseUrl}${api}${publication}${list}`,
    publicationChangeStatusUrl: () => `${baseUrl}${api}${publication}${changeStatus}`,
    fileUploadUrl: publicationItemId => `${baseUrl}${api}${file}/${publicationItemId}`,
    fileUrl: () => `${baseUrl}${api}${file}`,
    clientTokenUrl: () => `${baseUrl}${api}${clientToken}`,
    firebaseFileUrl: () => `${baseUrl}/${firebaseFile}`,
    fileLogsUrl: () => `${baseUrl}${api}${file}${logs}`,
    validateUserLimit: () => `${baseUrl}${api}${user}${validateLimit}`,
    membershipUrl: () => `${baseUrl}${api}${membership}`,
    membershipListUrl: () => `${baseUrl}${api}${membership}${list}`,
    membershipEnableUrl: () => `${baseUrl}${api}${membership}${enable}`,
    bannerUrl: () => `${baseUrl}${api}${banner}`,
    signedDocumentUrl: () => `${baseUrl}${api}${signedDocument}`,
    getSignableFilesList: () => `${baseUrl}${api}${file}${getSignableList}`
}